import React , {Component } from 'react';
import AUX from '../../../hoc/Aux_';
import { Link } from 'react-router-dom';

class Icons_material extends Component{
 
render(){
    return(
           <AUX>
            
        <div className="page-content-wrapper">
            <div className="container-fluid">

                <div className="row">
                    <div className="col-12">
                        <div className="card m-b-20">
                            <div className="card-body">

                                <h4 className="mt-0 header-title">Examples</h4>
                                <p className="text-muted m-b-30 font-14">Use <code>&lt;i className="mdi
                                    mdi-access-point"&gt;&lt;/i&gt;</code>.
                                </p>

                                <div className="row icon-demo-content">
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-access-point"></i> mdi mdi-access-point
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-access-point-network"></i> mdi mdi-access-point-network
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-account"></i> mdi mdi-account
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-account-box"></i> mdi mdi-account-box
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-account-box-outline"></i> mdi mdi-account-box-outline
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-account-card-details"></i> mdi mdi-account-card-details
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-account-check"></i> mdi mdi-account-check
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-account-circle"></i> mdi mdi-account-circle
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-account-convert"></i> mdi mdi-account-convert
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-account-key"></i> mdi mdi-account-key
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-account-location"></i> mdi mdi-account-location
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-account-minus"></i> mdi mdi-account-minus
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-account-multiple"></i> mdi mdi-account-multiple
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-account-multiple-minus"></i> mdi mdi-account-multiple-minus
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-account-multiple-outline"></i> mdi mdi-account-multiple-outline
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-account-multiple-plus"></i> mdi mdi-account-multiple-plus
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-account-network"></i> mdi mdi-account-network
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-account-off"></i> mdi mdi-account-off
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-account-outline"></i> mdi mdi-account-outline
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-account-plus"></i> mdi mdi-account-plus
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-account-remove"></i> mdi mdi-account-remove
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-account-search"></i> mdi mdi-account-search
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-account-settings"></i> mdi mdi-account-settings
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-account-settings-variant"></i> mdi mdi-account-settings-variant
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-account-star"></i> mdi mdi-account-star
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-account-star-variant"></i> mdi mdi-account-star-variant
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-account-switch"></i> mdi mdi-account-switch
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-adjust"></i> mdi mdi-adjust
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-air-conditioner"></i> mdi mdi-air-conditioner
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-airballoon"></i> mdi mdi-airballoon
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-airplane"></i> mdi mdi-airplane
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-airplane-landing"></i> mdi mdi-airplane-landing
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-airplane-off"></i> mdi mdi-airplane-off
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-airplane-takeoff"></i> mdi mdi-airplane-takeoff
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-airplay"></i> mdi mdi-airplay
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-alarm"></i> mdi mdi-alarm
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-alarm-check"></i> mdi mdi-alarm-check
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-alarm-multiple"></i> mdi mdi-alarm-multiple
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-alarm-off"></i> mdi mdi-alarm-off
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-alarm-plus"></i> mdi mdi-alarm-plus
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-album"></i> mdi mdi-albums
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-alert"></i> mdi mdi-alert
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-alert-box"></i> mdi mdi-alert-box
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-alert-circle"></i> mdi mdi-alert-circle
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-alert-circle-outline"></i> mdi mdi-alert-circle-outline
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-alert-octagon"></i> mdi mdi-alert-octagon
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-alert-outline"></i> mdi mdi-alert-outline
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-alpha"></i> mdi mdi-alpha
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-alphabetical"></i> mdi mdi-alphabetical
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-altimeter"></i> mdi mdi-altimeter
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-amazon"></i> mdi mdi-amazon
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-amazon-clouddrive"></i> mdi mdi-amazon-clouddrive
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-ambulance"></i> mdi mdi-ambulance
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-amplifier"></i> mdi mdi-amplifier
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-anchor"></i> mdi mdi-anchor
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-android"></i> mdi mdi-android
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-android-debug-bridge"></i> mdi mdi-android-debug-bridge
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-android-studio"></i> mdi mdi-android-studio
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-animation"></i> mdi mdi-animation
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-apple"></i> mdi mdi-apple
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-apple-finder"></i> mdi mdi-apple-finder
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-apple-ios"></i> mdi mdi-apple-ios
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-apple-keyboard-caps"></i> mdi mdi-apple-keyboard-caps
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-apple-keyboard-command"></i> mdi mdi-apple-keyboard-command
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-apple-keyboard-control"></i> mdi mdi-apple-keyboard-control
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-apple-keyboard-option"></i> mdi mdi-apple-keyboard-option
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-apple-keyboard-shift"></i> mdi mdi-apple-keyboard-shift
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-apple-mobileme "></i> mdi mdi-apple-mobileme
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-apple-safari"></i> mdi mdi-apple-safari
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-application"></i> mdi mdi-application
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-appnet"></i> mdi mdi-appnet
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-apps"></i> mdi mdi-apps
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-archive"></i> mdi mdi-archive
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-arrange-bring-forward"></i> mdi mdi-arrange-bring-forward
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-arrange-bring-to-front"></i> mdi mdi-arrange-bring-to-front
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-arrange-send-backward"></i> mdi mdi-arrange-send-backward
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-arrange-send-to-back"></i> mdi mdi-arrange-send-to-back
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-arrow-all"></i> mdi mdi-arrow-all
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-arrow-bottom-left"></i> mdi mdi-arrow-bottom-left
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-arrow-bottom-right"></i> mdi mdi-arrow-bottom-right
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-arrow-compress"></i> mdi mdi-arrow-compress
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-arrow-compress-all"></i> mdi mdi-arrow-compress-all
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-arrow-down"></i> mdi mdi-arrow-down
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-arrow-down"></i> mdi mdi-arrow-down
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-arrow-down-bold-circle"></i> mdi mdi-arrow-down-bold-circle
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-arrow-down-bold-circle-outline"></i> mdi mdi-arrow-down-bold-circle-outline
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-arrow-down-bold-hexagon-outline"></i> mdi mdi-arrow-down-bold-hexagon-outline
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-arrow-down-drop-circle"></i> mdi mdi-arrow-down-drop-circle
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-arrow-down-drop-circle-outline"></i> mdi mdi-arrow-down-drop-circle-outline
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-arrow-expand"></i> mdi mdi-arrow-expand
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-arrow-expand-all"></i> mdi mdi-arrow-expand-all
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-arrow-left"></i> mdi mdi-arrow-left
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-arrow-left-bold"></i> mdi mdi-arrow-left-bold
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-arrow-left-bold-circle"></i> mdi mdi-arrow-left-bold-circle
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-arrow-left-bold-circle-outline"></i> mdi mdi-arrow-left-bold-circle-outline
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-arrow-left-bold-hexagon-outline"></i> mdi mdi-arrow-left-bold-hexagon-outline
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-arrow-left-drop-circle"></i> mdi mdi-arrow-left-drop-circle
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-arrow-left-drop-circle-outline"></i> mdi mdi-arrow-left-drop-circle-outline
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-arrow-right"></i> mdi mdi-arrow-right
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-arrow-right-bold"></i> mdi mdi-arrow-right-bold
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-arrow-right-bold-circle"></i> mdi mdi-arrow-right-bold-circle
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-arrow-right-bold-circle-outline"></i> mdi mdi-arrow-right-bold-circle-outline
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-arrow-right-bold-hexagon-outline"></i> mdi mdi-arrow-right-bold-hexagon-outline
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-arrow-right-drop-circle"></i> mdi mdi-arrow-right-drop-circle
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-arrow-right-drop-circle-outline"></i> mdi mdi-arrow-right-drop-circle-outline
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-arrow-top-left"></i> mdi mdi-arrow-top-left
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-arrow-top-right"></i> mdi mdi-arrow-top-right
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-arrow-up"></i> mdi mdi-arrow-up
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-arrow-up-bold"></i> mdi mdi-arrow-up-bold
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-arrow-up-bold-circle"></i> mdi mdi-arrow-up-bold-circle
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-arrow-up-bold-circle-outline"></i> mdi mdi-arrow-up-bold-circle-outline
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-arrow-up-bold-hexagon-outline"></i> mdi mdi-arrow-up-bold-hexagon-outline
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-arrow-up-drop-circle"></i> mdi mdi-arrow-up-drop-circle
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-arrow-up-drop-circle-outline"></i> mdi mdi-arrow-up-drop-circle-outline
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-assistant"></i> mdi mdi-assistant
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-at"></i> mdi mdi-at
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-attachment"></i> mdi mdi-attachment
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-audiobook"></i> mdi mdi-audiobook
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-auto-fix"></i> mdi mdi-auto-fix
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-auto-upload"></i> mdi mdi-auto-upload
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-autorenew"></i> mdi mdi-autorenew
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-av-timer"></i> mdi mdi-av-timer
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-baby"></i> mdi mdi-baby
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-backburger"></i> mdi mdi-backburger
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-backspace"></i> mdi mdi-backspace
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-backup-restore"></i> mdi mdi-backup-restore
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-bank"></i> mdi mdi-bank
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-barcode"></i> mdi mdi-barcode
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-barcode-scan"></i> mdi mdi-barcode-scan
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-barley"></i> mdi mdi-barley
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-barrel"></i> mdi mdi-barrel
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-basecamp"></i> mdi mdi-basecamp
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-basket"></i> mdi mdi-basket
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-basket-fill"></i> mdi mdi-basket-fill
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-basket-unfill"></i> mdi mdi-basket-unfill
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-battery"></i> mdi mdi-battery
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-battery-10"></i> mdi mdi-battery-10
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-battery-20"></i> mdi mdi-battery-20
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-battery-30"></i> mdi mdi-battery-30
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-battery-40"></i> mdi mdi-battery-40
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-battery-50"></i> mdi mdi-battery-50
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-battery-60"></i> mdi mdi-battery-60
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-battery-70"></i> mdi mdi-battery-70
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-battery-80"></i> mdi mdi-battery-80
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-battery-90"></i> mdi mdi-battery-90
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-battery-alert"></i> mdi mdi-battery-alert
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-battery-charging"></i> mdi mdi-battery-charging
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-battery-charging-100"></i> mdi mdi-battery-charging-100
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-battery-charging-20"></i> mdi mdi-battery-charging-20
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-battery-charging-30"></i> mdi mdi-battery-charging-30
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-battery-charging-40"></i> mdi mdi-battery-charging-40
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-battery-charging-60"></i> mdi mdi-battery-charging-60
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-battery-charging-80"></i> mdi mdi-battery-charging-80
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-battery-charging-90"></i> mdi mdi-battery-charging-90
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-battery-minus"></i> mdi mdi-battery-minus
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-battery-negative"></i> mdi mdi-battery-negative
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-battery-outline"></i> mdi mdi-battery-outline
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-battery-plus"></i> mdi mdi-battery-plus
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-battery-positive"></i> mdi mdi-battery-positive
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-battery-unknown"></i> mdi mdi-battery-unknown
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-beach"></i> mdi mdi-beach
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-beats"></i> mdi mdi-beats
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-beer"></i> mdi mdi-beer
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-behance"></i> mdi mdi-behance
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-bell"></i> mdi mdi-bell
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-bell-off"></i> mdi mdi-bell-off
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-bell-outline"></i> mdi mdi-bell-outline
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-bell-plus"></i> mdi mdi-bell-plus
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-bell-ring"></i> mdi mdi-bell-ring
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-bell-ring-outline"></i> mdi mdi-bell-ring-outline
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-bell-sleep"></i> mdi mdi-bell-sleep
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-beta"></i> mdi mdi-beta
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-bible"></i> mdi mdi-bible
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-bike"></i> mdi mdi-bike
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-bing"></i> mdi mdi-bing
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-binoculars"></i> mdi mdi-binoculars
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-bio"></i> mdi mdi-bio
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-biohazard"></i> mdi mdi-biohazard
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-bitbucket"></i> mdi mdi-bitbucket
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-black-mesa"></i> mdi mdi-black-mesa
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-blackberry"></i> mdi mdi-blackberry
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-blender"></i> mdi mdi-blender
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-blinds"></i> mdi mdi-blinds
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-block-helper"></i> mdi mdi-block-helper
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-blogger"></i> mdi mdi-blogger
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-bluetooth"></i> mdi mdi-bluetooth
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-bluetooth-audio"></i> mdi mdi-bluetooth-audio
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-bluetooth-connect"></i> mdi mdi-bluetooth-connect
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-bluetooth-off"></i> mdi mdi-bluetooth-off
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-bluetooth-settings"></i> mdi mdi-bluetooth-settings
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-bluetooth-transfer"></i> mdi mdi-bluetooth-transfer
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-blur"></i> mdi mdi-blur
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-blur-linear"></i> mdi mdi-blur-linear
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-blur-off"></i> mdi mdi-blur-off
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-blur-radial"></i> mdi mdi-blur-radial
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-bone"></i> mdi mdi-bone
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-book"></i> mdi mdi-book
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-book-minus"></i> mdi mdi-book-minus
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-book-multiple"></i> mdi mdi-book-multiple
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-book-multiple-variant"></i> mdi mdi-book-multiple-variant
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-book-open"></i> mdi mdi-book-open
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-book-open-page-variant"></i> mdi mdi-book-open-page-variant
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-book-open-variant"></i> mdi mdi-book-open-variant
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-book-plus"></i> mdi mdi-book-plus
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-book-variant"></i> mdi mdi-book-variant
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-bookmark"></i> mdi mdi-bookmark
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-bookmark-check"></i> mdi mdi-bookmark-check
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-bookmark-music"></i> mdi mdi-bookmark-music
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-bookmark-outline"></i> mdi mdi-bookmark-outline
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-bookmark-plus"></i> mdi mdi-bookmark-plus
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-bookmark-plus-outline"></i> mdi mdi-bookmark-plus-outline
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-bookmark-remove"></i> mdi mdi-bookmark-remove
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-boombox"></i> mdi mdi-boombox
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-border-all"></i> mdi mdi-border-all
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-border-bottom"></i> mdi mdi-border-bottom
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-border-color"></i> mdi mdi-border-color
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-border-horizontal"></i> mdi mdi-border-horizontal
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-border-inside"></i> mdi mdi-border-inside
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-border-left"></i> mdi mdi-border-left
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-border-none"></i> mdi mdi-border-none
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-border-outside"></i> mdi mdi-border-outside
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-border-right"></i> mdi mdi-border-right
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-border-style"></i> mdi mdi-border-style
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-border-top"></i> mdi mdi-border-top
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-border-vertical"></i> mdi mdi-border-vertical
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-bowl"></i> mdi mdi-bowl
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-bowling"></i> mdi mdi-bowling
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-box"></i> mdi mdi-box
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-box-cutter"></i> mdi mdi-box-cutter
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-box-shadow"></i> mdi mdi-box-shadow
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-bridge"></i> mdi mdi-bridge
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-briefcase"></i> mdi mdi-briefcase
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-briefcase-check"></i> mdi mdi-briefcase-check
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-briefcase-download"></i> mdi mdi-briefcase-download
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-briefcase-upload"></i> mdi mdi-briefcase-upload
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-brightness-1"></i> mdi mdi-brightness-1
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-brightness-2"></i> mdi mdi-brightness-2
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-brightness-3"></i> mdi mdi-brightness-3
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-brightness-4"></i> mdi mdi-brightness-4
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-brightness-5"></i> mdi mdi-brightness-5
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-brightness-6"></i> mdi mdi-brightness-6
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-brightness-7"></i> mdi mdi-brightness-7
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-brightness-auto"></i> mdi mdi-brightness-auto
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-broom"></i> mdi mdi-broom
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-brush"></i> mdi mdi-brush
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-buffer"></i> mdi mdi-buffer
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-bug"></i> mdi mdi-bug
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-bulletin-board"></i> mdi mdi-bulletin-board
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-bullhorn"></i> mdi mdi-bullhorn
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-bullseye"></i> mdi mdi-bullseye
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-burst-mode"></i> mdi mdi-burst-mode
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-bus"></i> mdi mdi-bus
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-cached"></i> mdi mdi-cached
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-cake"></i> mdi mdi-cake
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-cake-layered"></i> mdi mdi-cake-layered
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-cake-variant"></i> mdi mdi-cake-variant
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-calculator"></i> mdi mdi-calculator
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-calendar"></i> mdi mdi-calendar
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-calendar-blank"></i> mdi mdi-calendar-blank
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-calendar-check"></i> mdi mdi-calendar-check
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-calendar-clock"></i> mdi mdi-calendar-clock
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-calendar-multiple"></i> mdi mdi-calendar-multiple
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-calendar-multiple-check"></i> mdi mdi-calendar-multiple-check
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-calendar-plus"></i> mdi mdi-calendar-plus
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-calendar-remove"></i> mdi mdi-calendar-remove
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-calendar-text"></i> mdi mdi-calendar-text
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-calendar-today"></i> mdi mdi-calendar-today
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-call-made"></i> mdi mdi-call-made
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-call-merge"></i> mdi mdi-call-merge
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-call-missed"></i> mdi mdi-call-missed
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-call-received"></i> mdi mdi-call-received
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-call-split"></i> mdi mdi-call-split
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-camcorder"></i> mdi mdi-camcorder
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-camcorder-box"></i> mdi mdi-camcorder-box
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-camcorder-box-off"></i> mdi mdi-camcorder-box-off
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-camcorder-off"></i> mdi mdi-camcorder-off
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-camera"></i> mdi mdi-camera
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-camera-enhance"></i> mdi mdi-camera-enhance
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-camera-front"></i> mdi mdi-camera-front
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-camera-front-variant"></i> mdi mdi-camera-front-variant
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-camera-iris"></i> mdi mdi-camera-iris
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-camera-off"></i> mdi mdi-camera-off
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-camera-party-mode"></i> mdi mdi-camera-party-mode
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-camera-rear"></i> mdi mdi-camera-rear
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-camera-rear-variant"></i> mdi mdi-camera-rear-variant
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-camera-switch"></i> mdi mdi-camera-switch
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-camera-timer"></i> mdi mdi-camera-timer
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-candle"></i> mdi mdi-candle
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-candycane"></i> mdi mdi-candycane
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-car"></i> mdi mdi-car
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-car-battery"></i> mdi mdi-car-battery
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-car-connected"></i> mdi mdi-car-connected
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-car-wash"></i> mdi mdi-car-wash
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-cards"></i> mdi mdi-cards
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-cards-outline"></i> mdi mdi-cards-outline
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-cards-playing-outline"></i> mdi mdi-cards-playing-outline
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-carrot"></i> mdi mdi-carrot
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-cart"></i> mdi mdi-cart
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-cart-off"></i> mdi mdi-cart-off
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-cart-outline"></i> mdi mdi-cart-outline
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-cart-plus"></i> mdi mdi-cart-plus
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-case-sensitive-alt"></i> mdi mdi-case-sensitive-alt
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-cash"></i> mdi mdi-cash
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-cash-100"></i> mdi mdi-cash-100
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-cash-multiple"></i> mdi mdi-cash-multiple
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-cash-usd"></i> mdi mdi-cash-usd
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-cast"></i> mdi mdi-cast
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-cast-connected"></i> mdi mdi-cast-connected
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-castle"></i> mdi mdi-castle
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-cat"></i> mdi mdi-cat
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-cellphone"></i> mdi mdi-cellphone
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-cellphone-android"></i> mdi mdi-cellphone-android
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-cellphone-basic"></i> mdi mdi-cellphone-basic
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-cellphone-dock"></i> mdi mdi-cellphone-dock
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-cellphone-iphone"></i> mdi mdi-cellphone-iphone
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-cellphone-link"></i> mdi mdi-cellphone-link
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-cellphone-link-off"></i> mdi mdi-cellphone-link-off
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-cellphone-settings"></i> mdi mdi-cellphone-settings
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-certificate"></i> mdi mdi-certificate
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-chair-school"></i> mdi mdi-chair-school
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-chart-arc"></i> mdi mdi-chart-arc
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-chart-areaspline"></i> mdi mdi-chart-areaspline
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-chart-bar"></i> mdi mdi-chart-bar
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-chart-bubble"></i> mdi mdi-chart-bubble
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-chart-gantt"></i> mdi mdi-chart-gantt
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-chart-gantt"></i> mdi mdi-chart-gantt
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-chart-histogram"></i> mdi mdi-chart-histogram
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-chart-line"></i> mdi mdi-chart-line
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-chart-pie"></i> mdi mdi-chart-pie
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-chart-scatterplot-hexbin"></i> mdi mdi-chart-scatterplot-hexbin
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-check"></i> mdi mdi-check
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-check-all"></i> mdi mdi-check-all
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-check-circle"></i> mdi mdi-check-circle
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-check-circle-outline"></i> mdi mdi-check-circle-outline
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-checkbox-blank"></i> mdi mdi-checkbox-blank
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-checkbox-blank-circle"></i> mdi mdi-checkbox-blank-circle
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-checkbox-blank-circle-outline"></i> mdi mdi-checkbox-blank-circle-outline
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-checkbox-blank-outline"></i> mdi mdi-checkbox-blank-outline
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-checkbox-marked"></i> mdi mdi-checkbox-marked
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-checkbox-marked-circle"></i> mdi mdi-checkbox-marked-circle
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-checkbox-marked-circle-outline"></i> mdi mdi-checkbox-marked-circle-outline
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-checkbox-marked-outline"></i> mdi mdi-checkbox-marked-outline
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-checkbox-multiple-blank"></i> mdi mdi-checkbox-multiple-blank
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-checkbox-multiple-blank-circle"></i> mdi mdi-checkbox-multiple-blank-circle
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-checkbox-multiple-blank-circle-outline"></i> mdi mdi-checkbox-multiple-blank-circle-outline
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-checkbox-multiple-blank-outline"></i> mdi mdi-checkbox-multiple-blank-outline
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-checkbox-multiple-marked"></i> mdi mdi-checkbox-multiple-marked
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-checkbox-multiple-marked-circle"></i> mdi mdi-checkbox-multiple-marked-circle
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-checkbox-multiple-marked-circle-outline"></i> mdi mdi-checkbox-multiple-marked-circle-outline
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-checkbox-multiple-marked-outline"></i> mdi mdi-checkbox-multiple-marked-outline
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-checkerboard"></i> mdi mdi-checkerboard
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-chemical-weapon"></i> mdi mdi-chemical-weapon
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-chemical-weapon"></i> mdi mdi-chemical-weapon
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-chevron-double-down"></i> mdi mdi-chevron-double-down
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-chevron-double-left"></i> mdi mdi-chevron-double-left
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-chevron-double-right"></i> mdi mdi-chevron-double-right
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-chevron-double-up"></i> mdi mdi-chevron-double-up
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-chevron-down"></i> mdi mdi-chevron-down
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-chevron-left"></i> mdi mdi-chevron-left
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-chevron-right"></i> mdi mdi-chevron-right
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-chevron-up"></i> mdi mdi-chevron-up
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-chip"></i> mdi mdi-chip
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-church"></i> mdi mdi-church
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-cisco-webex"></i> mdi mdi-cisco-webex
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-city"></i> mdi mdi-city
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-clipboard"></i> mdi mdi-clipboard
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-clipboard-account"></i> mdi mdi-clipboard-account
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-clipboard-alert"></i> mdi mdi-clipboard-alert
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-clipboard-arrow-down"></i> mdi mdi-clipboard-arrow-down
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-clipboard-arrow-left"></i> mdi mdi-clipboard-arrow-left
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-clipboard-check"></i> mdi mdi-clipboard-check
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-clipboard-outline"></i> mdi mdi-clipboard-outline
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-clipboard-text"></i> mdi mdi-clipboard-text
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-clippy"></i> mdi mdi-clippy
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-clock"></i> mdi mdi-clock
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-clock-alert"></i> mdi mdi-clock-alert
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-clock-end"></i> mdi mdi-clock-end
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-clock-fast"></i> mdi mdi-clock-fast
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-clock-in"></i> mdi mdi-clock-in
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-clock-out"></i> mdi mdi-clock-out
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-clock-start"></i> mdi mdi-clock-start
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-close"></i> mdi mdi-close
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-close-box"></i> mdi mdi-close-box
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-close-box-outline"></i> mdi mdi-close-box-outline
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-close-circle"></i> mdi mdi-close-circle
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-close-circle-outline"></i> mdi mdi-close-circle-outline
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-close-network"></i> mdi mdi-close-network
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-close-octagon"></i> mdi mdi-close-octagon
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-close-octagon-outline"></i> mdi mdi-close-octagon-outline
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-closed-caption"></i> mdi mdi-closed-caption
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-cloud"></i> mdi mdi-cloud
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-cloud-check"></i> mdi mdi-cloud-check
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-cloud-circle"></i> mdi mdi-cloud-circle
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-cloud-download"></i> mdi mdi-cloud-download
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-cloud-outline"></i> mdi mdi-cloud-outline
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-cloud-outline-off"></i> mdi mdi-cloud-outline-off
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-cloud-print"></i> mdi mdi-cloud-print
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-cloud-print-outline"></i> mdi mdi-cloud-print-outline
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-cloud-sync"></i> mdi mdi-cloud-sync
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-cloud-upload"></i> mdi mdi-cloud-upload
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-code-array"></i> mdi mdi-code-array
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-code-braces"></i> mdi mdi-code-braces
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-code-brackets"></i> mdi mdi-code-brackets
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-code-equal"></i> mdi mdi-code-equal
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-code-greater-than"></i> mdi mdi-code-greater-than
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-code-greater-than-or-equal"></i> mdi mdi-code-greater-than-or-equal
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-code-less-than"></i> mdi mdi-code-less-than
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-code-less-than-or-equal"></i> mdi mdi-code-less-than-or-equal
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-code-not-equal"></i> mdi mdi-code-not-equal
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-code-not-equal-variant"></i> mdi mdi-code-not-equal-variant
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-code-parentheses"></i> mdi mdi-code-parentheses
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-code-string"></i> mdi mdi-code-string
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-code-tags"></i> mdi mdi-code-tags
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-codepen"></i> mdi mdi-codepen
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-coffee"></i> mdi mdi-coffee
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-coffee-to-go"></i> mdi mdi-coffee-to-go
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-coin"></i> mdi mdi-coin
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-collage"></i> mdi mdi-collage
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-color-helper"></i> mdi mdi-color-helper
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-comment"></i> mdi mdi-comment
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-comment-account"></i> mdi mdi-comment-account
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-comment-account-outline"></i> mdi mdi-comment-account-outline
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-comment-alert"></i> mdi mdi-comment-alert
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-comment-alert-outline"></i> mdi mdi-comment-alert-outline
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-comment-check"></i> mdi mdi-comment-check
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-comment-check-outline"></i> mdi mdi-comment-check-outline
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-comment-multiple-outline"></i> mdi mdi-comment-multiple-outline
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-comment-outline"></i> mdi mdi-comment-outline
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-comment-plus-outline"></i> mdi mdi-comment-plus-outline
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-comment-processing"></i> mdi mdi-comment-processing
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-comment-processing-outline"></i> mdi mdi-comment-processing-outline
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-comment-question-outline"></i> mdi mdi-comment-question-outline
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-comment-remove-outline"></i> mdi mdi-comment-remove-outline
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-comment-text"></i> mdi mdi-comment-text
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-comment-text-outline"></i> mdi mdi-comment-text-outline
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-compare"></i> mdi mdi-compare
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-compass"></i> mdi mdi-compass
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-compass-outline"></i> mdi mdi-compass-outline
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-console"></i> mdi mdi-console
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-contact-mail"></i> mdi mdi-contact-mail
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-content-copy"></i> mdi mdi-content-copy
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-content-cut"></i> mdi mdi-content-cut
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-content-duplicate"></i> mdi mdi-content-duplicate
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-content-paste"></i> mdi mdi-content-paste
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-content-save"></i> mdi mdi-content-save
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-content-save-all"></i> mdi mdi-content-save-all
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-content-save-settings"></i> mdi mdi-content-save-settings
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-contrast"></i> mdi mdi-contrast
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-contrast-box"></i> mdi mdi-contrast-box
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-contrast-circle"></i> mdi mdi-contrast-circle
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-cookie"></i> mdi mdi-cookie
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-copyright"></i> mdi mdi-copyright
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-counter"></i> mdi mdi-counter
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-cow"></i> mdi mdi-cow
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-credit-card"></i> mdi mdi-credit-card
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-credit-card-multiple"></i> mdi mdi-credit-card-multiple
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-credit-card-off"></i> mdi mdi-credit-card-off
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-credit-card-scan"></i> mdi mdi-credit-card-scan
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-crop"></i> mdi mdi-crop
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-crop-free"></i> mdi mdi-crop-free
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-crop-landscape"></i> mdi mdi-crop-landscape
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-crop-portrait"></i> mdi mdi-crop-portrait
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-crop-square"></i> mdi mdi-crop-square
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-crosshairs"></i> mdi mdi-crosshairs
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-crosshairs-gps"></i> mdi mdi-crosshairs-gps
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-crown"></i> mdi mdi-crown
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-cube"></i> mdi mdi-cube
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-cube-outline"></i> mdi mdi-cube-outline
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-cube-send"></i> mdi mdi-cube-send
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-cube-unfolded"></i> mdi mdi-cube-unfolded
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-cup"></i> mdi mdi-cup
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-cup-off"></i> mdi mdi-cup-off
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-cup-water"></i> mdi mdi-cup-water
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-currency-btc"></i> mdi mdi-currency-btc
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-currency-eur"></i> mdi mdi-currency-eur
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-currency-gbp"></i> mdi mdi-currency-gbp
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-currency-inr"></i> mdi mdi-currency-inr
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-currency-ngn"></i> mdi mdi-currency-ngn
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-currency-rub"></i> mdi mdi-currency-rub
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-currency-try"></i> mdi mdi-currency-try
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-currency-usd"></i> mdi mdi-currency-usd
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-cursor-default"></i> mdi mdi-cursor-default
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-cursor-default-outline"></i> mdi mdi-cursor-default-outline
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-cursor-move"></i> mdi mdi-cursor-move
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-cursor-pointer"></i> mdi mdi-cursor-pointer
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-cursor-text"></i> mdi mdi-cursor-text
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-database"></i> mdi mdi-database
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-database-minus"></i> mdi mdi-database-minus
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-database-plus"></i> mdi mdi-database-plus
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-debug-step-into"></i> mdi mdi-debug-step-into
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-debug-step-out"></i> mdi mdi-debug-step-out
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-debug-step-over"></i> mdi mdi-debug-step-over
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-decimal-decrease"></i> mdi mdi-decimal-decrease
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-delete"></i> mdi mdi-delete
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-delete-forever"></i> mdi mdi-delete-forever
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-delete-sweep"></i> mdi mdi-delete-sweep
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-delete-variant"></i> mdi mdi-delete-variant
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-delta"></i> mdi mdi-delta
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-deskphone"></i> mdi mdi-deskphone
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-desktop-mac"></i> mdi mdi-desktop-mac
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-desktop-tower"></i> mdi mdi-desktop-tower
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-details"></i> mdi mdi-details
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-deviantart"></i> mdi mdi-deviantart
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-dialpad"></i> mdi mdi-dialpad
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-diamond"></i> mdi mdi-diamond
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-dice-1"></i> mdi mdi-dice-1
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-dice-2"></i> mdi mdi-dice-2
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-dice-3"></i> mdi mdi-dice-3
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-dice-4"></i> mdi mdi-dice-4
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-dice-5"></i> mdi mdi-dice-5
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-dice-6"></i> mdi mdi-dice-6
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-dice-d20"></i> mdi mdi-dice-d20
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-dice-d4"></i> mdi mdi-dice-d4
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-dice-d6"></i> mdi mdi-dice-d6
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-dice-d8"></i> mdi mdi-dice-d8
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-dictionary"></i> mdi mdi-dictionary
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-directions"></i> mdi mdi-directions
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-directions-fork"></i> mdi mdi-directions-fork
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-discord"></i> mdi mdi-discord
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-disk"></i> mdi mdi-disk
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-disk-alert"></i> mdi mdi-disk-alert
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-disqus"></i> mdi mdi-disqus
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-disqus-outline"></i> mdi mdi-disqus-outline
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-division"></i> mdi mdi-division
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-division-box"></i> mdi mdi-division-box
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-dns"></i> mdi mdi-dns
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-domain"></i> mdi mdi-domain
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-dots-horizontal"></i> mdi mdi-dots-horizontal
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-dots-vertical"></i> mdi mdi-dots-vertical
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-download"></i> mdi mdi-download
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-drag"></i> mdi mdi-drag
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-drag-horizontal"></i> mdi mdi-drag-horizontal
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-drag-vertical"></i> mdi mdi-drag-vertical
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-drawing"></i> mdi mdi-drawing
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-drawing-box"></i> mdi mdi-drawing-box
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-dribbble"></i> mdi mdi-dribbble
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-dribbble-box"></i> mdi mdi-dribbble-box
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-drone"></i> mdi mdi-drone
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-dropbox"></i> mdi mdi-dropbox
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-drupal"></i> mdi mdi-drupal
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-duck"></i> mdi mdi-duck
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-dumbbell"></i> mdi mdi-dumbbell
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-earth"></i> mdi mdi-earth
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-earth-off"></i> mdi mdi-earth-off
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-edge"></i> mdi mdi-edge
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-eject"></i> mdi mdi-eject
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-elevation-decline"></i> mdi mdi-elevation-decline
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-elevation-rise"></i> mdi mdi-elevation-rise
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-elevator"></i> mdi mdi-elevator
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-email"></i> mdi mdi-email
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-email-open"></i> mdi mdi-email-open
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-email-open-outline"></i> mdi mdi-email-open-outline
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-email-outline"></i> mdi mdi-email-outline
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-email-secure"></i> mdi mdi-email-secure
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-email-variant"></i> mdi mdi-email-variant
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-emoticon"></i> mdi mdi-emoticon
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-emoticon-cool"></i> mdi mdi-emoticon-cool
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-emoticon-devil"></i> mdi mdi-emoticon-devil
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-emoticon-happy"></i> mdi mdi-emoticon-happy
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-emoticon-neutral"></i> mdi mdi-emoticon-neutral
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-emoticon-poop"></i> mdi mdi-emoticon-poop
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-emoticon-sad"></i> mdi mdi-emoticon-sad
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-emoticon-tongue"></i> mdi mdi-emoticon-tongue
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-engine"></i> mdi mdi-engine
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-engine-outline"></i> mdi mdi-engine-outline
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-equal"></i> mdi mdi-equal
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-equal-box"></i> mdi mdi-equal-box
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-eraser"></i> mdi mdi-eraser
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-eraser-variant"></i> mdi mdi-eraser-variant
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-escalator"></i> mdi mdi-escalator
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-ethernet"></i> mdi mdi-ethernet
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-ethernet-cable"></i> mdi mdi-ethernet-cable
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-ethernet-cable-off"></i> mdi mdi-ethernet-cable-off
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-etsy"></i> mdi mdi-etsy
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-ev-station"></i> mdi mdi-ev-station
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-evernote"></i> mdi mdi-evernote
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-exclamation"></i> mdi mdi-exclamation
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-exit-to-app"></i> mdi mdi-exit-to-app
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-export"></i> mdi mdi-export
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-eye"></i> mdi mdi-eye
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-eye-off"></i> mdi mdi-eye-off
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-eyedropper"></i> mdi mdi-eyedropper
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-eyedropper-variant"></i> mdi mdi-eyedropper-variant
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-face"></i> mdi mdi-face
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-face-profile"></i> mdi mdi-face-profile
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-facebook"></i> mdi mdi-facebook
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-facebook-box"></i> mdi mdi-facebook-box
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-facebook-messenger"></i> mdi mdi-facebook-messenger
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-factory"></i> mdi mdi-factory
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-fan"></i> mdi mdi-fan
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-fast-forward"></i> mdi mdi-fast-forward
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-fax"></i> mdi mdi-fax
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-ferry"></i> mdi mdi-ferry
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-file"></i> mdi mdi-file
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-file-chart"></i> mdi mdi-file-chart
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-file-check"></i> mdi mdi-file-check
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-file-cloud"></i> mdi mdi-file-cloud
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-file-delimited"></i> mdi mdi-file-delimited
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-file-document"></i> mdi mdi-file-document
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-file-document-box"></i> mdi mdi-file-document-box
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-file-excel"></i> mdi mdi-file-excel
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-file-excel-box"></i> mdi mdi-file-excel-box
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-file-export"></i> mdi mdi-file-export
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-file-find"></i> mdi mdi-file-find
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-file-hidden"></i> mdi mdi-file-hidden
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-file-image"></i> mdi mdi-file-image
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-file-import"></i> mdi mdi-file-import
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-file-lock"></i> mdi mdi-file-lock
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-file-multiple"></i> mdi mdi-file-multiple
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-file-music"></i> mdi mdi-file-music
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-file-outline"></i> mdi mdi-file-outline
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-file-pdf"></i> mdi mdi-file-pdf
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-file-pdf-box"></i> mdi mdi-file-pdf-box
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-file-powerpoint"></i> mdi mdi-file-powerpoint
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-file-powerpoint-box"></i> mdi mdi-file-powerpoint-box
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-file-restore"></i> mdi mdi-file-restore
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-file-send"></i> mdi mdi-file-send
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-file-tree"></i> mdi mdi-file-tree
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-file-video"></i> mdi mdi-file-video
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-file-word"></i> mdi mdi-file-word
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-file-word-box"></i> mdi mdi-file-word-box
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-file-xml"></i> mdi mdi-file-xml
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-film"></i> mdi mdi-film
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-filmstrip"></i> mdi mdi-filmstrip
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-filmstrip-off"></i> mdi mdi-filmstrip-off
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-filter"></i> mdi mdi-filter
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-filter-outline"></i> mdi mdi-filter-outline
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-filter-remove"></i> mdi mdi-filter-remove
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-filter-remove-outline"></i> mdi mdi-filter-remove-outline
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-filter-variant"></i> mdi mdi-filter-variant
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-fingerprint"></i> mdi mdi-fingerprint
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-fire"></i> mdi mdi-fire
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-firefox"></i> mdi mdi-firefox
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-fish"></i> mdi mdi-fish
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-flag"></i> mdi mdi-flag
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-flag-checkered"></i> mdi mdi-flag-checkered
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-flag-outline"></i> mdi mdi-flag-outline
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-flag-outline-variant"></i> mdi mdi-flag-outline-variant
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-flag-triangle"></i> mdi mdi-flag-triangle
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-flag-variant"></i> mdi mdi-flag-variant
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-flash"></i> mdi mdi-flash
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-flash-auto"></i> mdi mdi-flash-auto
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-flash-off"></i> mdi mdi-flash-off
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-flashlight"></i> mdi mdi-flashlight
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-flashlight-off"></i> mdi mdi-flashlight-off
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-flask"></i> mdi mdi-flask
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-flask-empty"></i> mdi mdi-flask-empty
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-flask-empty-outline"></i> mdi mdi-flask-empty-outline
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-flask-outline"></i> mdi mdi-flask-outline
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-flattr"></i> mdi mdi-flattr
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-flask-empty"></i> mdi mdi-flask-empty
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-flask-empty-outline"></i> mdi mdi-flask-empty-outline
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-flask-outline"></i> mdi mdi-flask-outline
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-flattr"></i> mdi mdi-flattr
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-flip-to-back"></i> mdi mdi-flip-to-back
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-flip-to-front"></i> mdi mdi-flip-to-front
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-floppy"></i> mdi mdi-floppy
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-flower"></i> mdi mdi-flower
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-folder"></i> mdi mdi-folder
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-folder-account"></i> mdi mdi-folder-account
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-folder-download"></i> mdi mdi-folder-download
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-folder-google-drive"></i> mdi mdi-folder-google-drive
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-folder-image"></i> mdi mdi-folder-image
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-folder-lock"></i> mdi mdi-folder-lock
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-folder-lock-open"></i> mdi mdi-folder-lock-open
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-folder-move"></i> mdi mdi-folder-move
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-folder-multiple"></i> mdi mdi-folder-multiple
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-folder-multiple-image"></i> mdi mdi-folder-multiple-image
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-folder-multiple-outline"></i> mdi mdi-folder-multiple-outline
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-folder-outline"></i> mdi mdi-folder-outline
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-folder-plus"></i> mdi mdi-folder-plus
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-folder-remove"></i> mdi mdi-folder-remove
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-folder-upload"></i> mdi mdi-folder-upload
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-food"></i> mdi mdi-food
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-food-apple"></i> mdi mdi-food-apple
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-food-fork-drink"></i> mdi mdi-food-fork-drink
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-food-off"></i> mdi mdi-food-off
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-food-variant"></i> mdi mdi-food-variant
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-football"></i> mdi mdi-football
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-football-australian"></i> mdi mdi-football-australian
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-football-helmet"></i> mdi mdi-football-helmet
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-format-align-center"></i> mdi mdi-format-align-center
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-format-align-justify"></i> mdi mdi-format-align-justify
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-format-align-left"></i> mdi mdi-format-align-left
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-format-align-right"></i> mdi mdi-format-align-right
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-format-annotation-plus"></i> mdi mdi-format-annotation-plus
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-format-bold"></i> mdi mdi-format-bold
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-format-clear"></i> mdi mdi-format-clear
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-format-color-fill"></i> mdi mdi-format-color-fill
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-format-float-center"></i> mdi mdi-format-float-center
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-format-float-left"></i> mdi mdi-format-float-left
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-format-float-none"></i> mdi mdi-format-float-none
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-format-float-right"></i> mdi mdi-format-float-right
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-format-header-1"></i> mdi mdi-format-header-1
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-format-header-2"></i> mdi mdi-format-header-2
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-format-header-3"></i> mdi mdi-format-header-3
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-format-header-4"></i> mdi mdi-format-header-4
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-format-header-5"></i> mdi mdi-format-header-5
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-format-header-6"></i> mdi mdi-format-header-6
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-format-header-decrease"></i> mdi mdi-format-header-decrease
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-format-header-equal"></i> mdi mdi-format-header-equal
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-format-header-increase"></i> mdi mdi-format-header-increase
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-format-header-pound"></i> mdi mdi-format-header-pound
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-format-horizontal-align-center"></i> mdi mdi-format-horizontal-align-center
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-format-horizontal-align-left"></i> mdi mdi-format-horizontal-align-left
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-format-horizontal-align-right"></i> mdi mdi-format-horizontal-align-right
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-format-indent-decrease"></i> mdi mdi-format-indent-decrease
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-format-indent-increase"></i> mdi mdi-format-indent-increase
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-format-italic"></i> mdi mdi-format-italic
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-format-line-spacing"></i> mdi mdi-format-line-spacing
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-format-line-style"></i> mdi mdi-format-line-style
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-format-line-weight"></i> mdi mdi-format-line-weight
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-format-list-bulleted"></i> mdi mdi-format-list-bulleted
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-format-list-bulleted-type"></i> mdi mdi-format-list-bulleted-type
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-format-list-numbers"></i> mdi mdi-format-list-numbers
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-format-paint"></i> mdi mdi-format-paint
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-format-paragraph"></i> mdi mdi-format-paragraph
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-format-quote"></i> mdi mdi-format-quote
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-format-size"></i> mdi mdi-format-size
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-format-strikethrough"></i> mdi mdi-format-strikethrough
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-format-strikethrough-variant"></i> mdi mdi-format-strikethrough-variant
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-format-subscript"></i> mdi mdi-format-subscript
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-format-superscript"></i> mdi mdi-format-superscript
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-format-text"></i> mdi mdi-format-text
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-format-textdirection-l-to-r"></i> mdi mdi-format-textdirection-l-to-r
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-format-textdirection-r-to-l"></i> mdi mdi-format-textdirection-r-to-l
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-format-title"></i> mdi mdi-format-title
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-format-underline"></i> mdi mdi-format-underline
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-format-vertical-align-bottom"></i> mdi mdi-format-vertical-align-bottom
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-format-vertical-align-center"></i> mdi mdi-format-vertical-align-center
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-format-vertical-align-top"></i> mdi mdi-format-vertical-align-top
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-format-wrap-inline"></i> mdi mdi-format-wrap-inline
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-format-wrap-square"></i> mdi mdi-format-wrap-square
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-format-wrap-tight"></i> mdi mdi-format-wrap-tight
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-format-wrap-top-bottom"></i> mdi mdi-format-wrap-top-bottom
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-forum"></i> mdi mdi-forum
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-forward"></i> mdi mdi-forward
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-foursquare"></i> mdi mdi-foursquare
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-fridge"></i> mdi mdi-fridge
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-fridge-filled"></i> mdi mdi-fridge-filled
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-fridge-filled-bottom"></i> mdi mdi-fridge-filled-bottom
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-fridge-filled-top"></i> mdi mdi-fridge-filled-top
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-fullscreen"></i> mdi mdi-fullscreen
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-fullscreen-exit"></i> mdi mdi-fullscreen-exit
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-function"></i> mdi mdi-function
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-gamepad"></i> mdi mdi-gamepad
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-gamepad-variant"></i> mdi mdi-gamepad-variant
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-gas-cylinder"></i> mdi mdi-gas-cylinder
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-gas-station"></i> mdi mdi-gas-station
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-gate"></i> mdi mdi-gate
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-gauge"></i> mdi mdi-gauge
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-gavel"></i> mdi mdi-gavel
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-gender-female"></i> mdi mdi-gender-female
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-gender-male"></i> mdi mdi-gender-male
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-gender-male-female"></i> mdi mdi-gender-male-female
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-gender-transgender"></i> mdi mdi-gender-transgender
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-ghost"></i> mdi mdi-ghost
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-gift"></i> mdi mdi-gift
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-git"></i> mdi mdi-git
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-github-box"></i> mdi mdi-github-box
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-github-circle"></i> mdi mdi-github-circle
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-glass-flute"></i> mdi mdi-glass-flute
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-glass-mug"></i> mdi mdi-glass-mug
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-glass-stange"></i> mdi mdi-glass-stange
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-glass-tulip"></i> mdi mdi-glass-tulip
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-glassdoor"></i> mdi mdi-glassdoor
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-glasses"></i> mdi mdi-glasses
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-gmail"></i> mdi mdi-gmail
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-gnome"></i> mdi mdi-gnome
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-google"></i> mdi mdi-google
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-google-cardboard"></i> mdi mdi-google-cardboard
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-google-chrome"></i> mdi mdi-google-chrome
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-google-circles"></i> mdi mdi-google-circles
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-google-circles-communities"></i> mdi mdi-google-circles-communities
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-google-circles-extended"></i> mdi mdi-google-circles-extended
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-google-circles-group"></i> mdi mdi-google-circles-group
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-google-controller"></i> mdi mdi-google-controller
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-google-controller-off"></i> mdi mdi-google-controller-off
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-google-drive"></i> mdi mdi-google-drive
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-google-earth"></i> mdi mdi-google-earth
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-google-glass"></i> mdi mdi-google-glass
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-google-maps"></i> mdi mdi-google-maps
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-google-nearby"></i> mdi mdi-google-nearby
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-google-pages"></i> mdi mdi-google-pages
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-google-physical-web"></i> mdi mdi-google-physical-web
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-google-play"></i> mdi mdi-google-play
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-google-plus"></i> mdi mdi-google-plus
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-google-plus-box"></i> mdi mdi-google-plus-box
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-google-translate"></i> mdi mdi-google-translate
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-google-wallet"></i> mdi mdi-google-wallet
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-grease-pencil"></i> mdi mdi-grease-pencil
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-grid"></i> mdi mdi-grid
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-grid-off"></i> mdi mdi-grid-off
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-group"></i> mdi mdi-group
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-grid-off"></i> mdi mdi-grid-off
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-group"></i> mdi mdi-group
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-guitar-electric"></i> mdi mdi-guitar-electric
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-guitar-pick"></i> mdi mdi-guitar-pick
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-guitar-pick-outline"></i> mdi mdi-guitar-pick-outline
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-guitar-pick-outline"></i> mdi mdi-guitar-pick-outline
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-hackernews"></i> mdi mdi-hackernews
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-hand-pointing-right"></i> mdi mdi-hand-pointing-right
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-hanger"></i> mdi mdi-hanger
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-hangouts"></i> mdi mdi-hangouts
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-harddisk"></i> mdi mdi-harddisk
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-headphones"></i> mdi mdi-headphones
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-headphones-box"></i> mdi mdi-headphones-box
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-headphones-settings"></i> mdi mdi-headphones-settings
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-headset"></i> mdi mdi-headset
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-headset-dock"></i> mdi mdi-headset-dock
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-headset-off"></i> mdi mdi-headset-off
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-heart"></i> mdi mdi-heart
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-heart-box"></i> mdi mdi-heart-box
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-heart-box-outline"></i> mdi mdi-heart-box-outline
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-heart-broken"></i> mdi mdi-heart-broken
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-heart-outline"></i> mdi mdi-heart-outline
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-heart-pulse"></i> mdi mdi-heart-pulse
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-help"></i> mdi mdi-help
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-help-circle"></i> mdi mdi-help-circle
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-help-circle-outline"></i> mdi mdi-help-circle-outline
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-hexagon"></i> mdi mdi-hexagon
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-hexagon-outline"></i> mdi mdi-hexagon-outline
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-highway"></i> mdi mdi-highway
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-history"></i> mdi mdi-history
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-hololens"></i> mdi mdi-hololens
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-home"></i> mdi mdi-home
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-home-map-marker"></i> mdi mdi-home-map-marker
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-home-modern"></i> mdi mdi-home-modern
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-home-variant"></i> mdi mdi-home-variant
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-hops"></i> mdi mdi-hops
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-hospital"></i> mdi mdi-hospital
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-hospital-building"></i> mdi mdi-hospital-building
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-hospital-marker"></i> mdi mdi-hospital-marker
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-hotel"></i> mdi mdi-hotel
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-houzz"></i> mdi mdi-houzz
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-houzz-box"></i> mdi mdi-houzz-box
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-human"></i> mdi mdi-human
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-human-child"></i> mdi mdi-human-child
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-human-female"></i> mdi mdi-human-female
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-human-greeting"></i> mdi mdi-human-greeting
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-human-handsdown"></i> mdi mdi-human-handsdown
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-human-handsup"></i> mdi mdi-human-handsup
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-human-male"></i> mdi mdi-human-male
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-human-male-female"></i> mdi mdi-human-male-female
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-human-pregnant"></i> mdi mdi-human-pregnant
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-image"></i> mdi mdi-image
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-image-album"></i> mdi mdi-image-album
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-image-area"></i> mdi mdi-image-area
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-image-area-close"></i> mdi mdi-image-area-close
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-image-broken"></i> mdi mdi-image-broken
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-image-broken-variant"></i> mdi mdi-image-broken-variant
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-image-filter"></i> mdi mdi-image-filter
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-image-filter-black-white"></i> mdi mdi-image-filter-black-white
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-image-filter-center-focus"></i> mdi mdi-image-filter-center-focus
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-image-filter-center-focus-weak"></i> mdi mdi-image-filter-center-focus-weak
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-image-filter-drama"></i> mdi mdi-image-filter-drama
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-image-filter-frames"></i> mdi mdi-image-filter-frames
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-image-filter-hdr"></i> mdi mdi-image-filter-hdr
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-image-filter-none"></i> mdi mdi-image-filter-none
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-image-filter-tilt-shift"></i> mdi mdi-image-filter-tilt-shift
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-image-filter-vintage"></i> mdi mdi-image-filter-vintage
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-image-multiple"></i> mdi mdi-image-multiple
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-import"></i> mdi mdi-import
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-inbox"></i> mdi mdi-inbox
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-incognito"></i> mdi mdi-incognito
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-information"></i> mdi mdi-information
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-information-outline"></i> mdi mdi-information-outline
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-information-variant"></i> mdi mdi-information-variant
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-instagram"></i> mdi mdi-instagram
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-instapaper"></i> mdi mdi-instapaper
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-internet-explorer"></i> mdi mdi-internet-explorer
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-invert-colors"></i> mdi mdi-invert-colors
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-jeepney"></i> mdi mdi-jeepney
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-jira"></i> mdi mdi-jira
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-jsfiddle"></i> mdi mdi-jsfiddle
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-json"></i> mdi mdi-json
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-keg"></i> mdi mdi-keg
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-kettle"></i> mdi mdi-kettle
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-key"></i> mdi mdi-key
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-key-change"></i> mdi mdi-key-change
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-key-minus"></i> mdi mdi-key-minus
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-key-plus"></i> mdi mdi-key-plus
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-key-remove"></i> mdi mdi-key-remove
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-key-variant"></i> mdi mdi-key-variant
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-keyboard"></i> mdi mdi-keyboard
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-keyboard-backspace"></i> mdi mdi-keyboard-backspace
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-keyboard-caps"></i> mdi mdi-keyboard-caps
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-keyboard-close"></i> mdi mdi-keyboard-close
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-keyboard-off"></i> mdi mdi-keyboard-off
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-keyboard-return"></i> mdi mdi-keyboard-return
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-keyboard-tab"></i> mdi mdi-keyboard-tab
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-keyboard-variant"></i> mdi mdi-keyboard-variant
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-kodi"></i> mdi mdi-kodi
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-label"></i> mdi mdi-label
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-label-outline"></i> mdi mdi-label-outline
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-lambda"></i> mdi mdi-lambda
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-lan"></i> mdi mdi-lan
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-lan-connect"></i> mdi mdi-lan-connect
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-lan-disconnect"></i> mdi mdi-lan-disconnect
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-lan-pending"></i> mdi mdi-lan-pending
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-language-c"></i> mdi mdi-language-c
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-language-cpp"></i> mdi mdi-language-cpp
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-language-csharp"></i> mdi mdi-language-csharp
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-language-css3"></i> mdi mdi-language-css3
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-language-html5"></i> mdi mdi-language-html5
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-language-javascript"></i> mdi mdi-language-javascript
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-language-php"></i> mdi mdi-language-php
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-language-python"></i> mdi mdi-language-python
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-language-python-text"></i> mdi mdi-language-python-text
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-laptop"></i> mdi mdi-laptop
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-laptop-chromebook"></i> mdi mdi-laptop-chromebook
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-laptop-mac"></i> mdi mdi-laptop-mac
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-laptop-windows"></i> mdi mdi-laptop-windows
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-lastfm"></i> mdi mdi-lastfm
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-launch"></i> mdi mdi-launch
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-layers"></i> mdi mdi-layers
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-layers-off"></i> mdi mdi-layers-off
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-lead-pencil"></i> mdi mdi-lead-pencil
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-leaf"></i> mdi mdi-leaf
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-led-off"></i> mdi mdi-led-off
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-led-on"></i> mdi mdi-led-on
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-led-outline"></i> mdi mdi-led-outline
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-led-variant-off"></i> mdi mdi-led-variant-off
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-led-variant-on"></i> mdi mdi-led-variant-on
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-led-variant-outline"></i> mdi mdi-led-variant-outline
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-library"></i> mdi mdi-library
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-library-books"></i> mdi mdi-library-books
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-library-music"></i> mdi mdi-library-music
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-library-plus"></i> mdi mdi-library-plus
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-lightbulb"></i> mdi mdi-lightbulb
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-lightbulb-outline"></i> mdi mdi-lightbulb-outline
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-link"></i> mdi mdi-link
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-link-off"></i> mdi mdi-link-off
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-link-variant"></i> mdi mdi-link-variant
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-link-variant-off"></i> mdi mdi-link-variant-off
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-linkedin"></i> mdi mdi-linkedin
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-linkedin-box"></i> mdi mdi-linkedin-box
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-linux"></i> mdi mdi-linux
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-lock"></i> mdi mdi-lock
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-lock-open"></i> mdi mdi-lock-open
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-lock-open-outline"></i> mdi mdi-lock-open-outline
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-lock-outline"></i> mdi mdi-lock-outline
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-lock-plus"></i> mdi mdi-lock-plus
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-login"></i> mdi mdi-login
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-login-variant"></i> mdi mdi-login-variant
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-logout"></i> mdi mdi-logout
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-logout-variant"></i> mdi mdi-logout-variant
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-looks"></i> mdi mdi-looks
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-loupe"></i> mdi mdi-loupe
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-lumx"></i> mdi mdi-lumx
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-magnet"></i> mdi mdi-magnet
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-magnet-on"></i> mdi mdi-magnet-on
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-magnify"></i> mdi mdi-magnify
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-magnify-minus"></i> mdi mdi-magnify-minus
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-magnify-plus"></i> mdi mdi-magnify-plus
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-mail-ru"></i> mdi mdi-mail-ru
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-map"></i> mdi mdi-map
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-map-marker"></i> mdi mdi-map-marker
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-map-marker-circle"></i> mdi mdi-map-marker-circle
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-map-marker-minus"></i> mdi mdi-map-marker-minus
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-map-marker-multiple"></i> mdi mdi-map-marker-multiple
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-map-marker-off"></i> mdi mdi-map-marker-off
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-map-marker-plus"></i> mdi mdi-map-marker-plus
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-map-marker-radius"></i> mdi mdi-map-marker-radius
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-margin"></i> mdi mdi-margin
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-markdown"></i> mdi mdi-markdown
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-marker"></i> mdi mdi-marker
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-marker-check"></i> mdi mdi-marker-check
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-martini"></i> mdi mdi-martini
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-material-ui"></i> mdi mdi-material-ui
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-math-compass"></i> mdi mdi-math-compass
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-matrix"></i> mdi mdi-matrix
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-maxcdn"></i> mdi mdi-maxcdn
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-medium"></i> mdi mdi-medium
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-memory"></i> mdi mdi-memory
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-menu"></i> mdi mdi-menu
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-menu-down"></i> mdi mdi-menu-down
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-menu-left"></i> mdi mdi-menu-left
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-menu-right"></i> mdi mdi-menu-right
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-menu-up"></i> mdi mdi-menu-up
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-message"></i> mdi mdi-message
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-message-alert"></i> mdi mdi-message-alert
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-message-draw"></i> mdi mdi-message-draw
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-message-image"></i> mdi mdi-message-image
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-message-outline"></i> mdi mdi-message-outline
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-message-plus"></i> mdi mdi-message-plus
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-message-processing"></i> mdi mdi-message-processing
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-message-reply"></i> mdi mdi-message-reply
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-message-reply-text"></i> mdi mdi-message-reply-text
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-message-text"></i> mdi mdi-message-text
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-message-text-outline"></i> mdi mdi-message-text-outline
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-message-video"></i> mdi mdi-message-video
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-meteor"></i> mdi mdi-meteor
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-microphone"></i> mdi mdi-microphone
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-microphone-off"></i> mdi mdi-microphone-off
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-microphone-outline"></i> mdi mdi-microphone-outline
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-microphone-settings"></i> mdi mdi-microphone-settings
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-microphone-variant"></i> mdi mdi-microphone-variant
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-microphone-variant-off"></i> mdi mdi-microphone-variant-off
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-microscope"></i> mdi mdi-microscope
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-microsoft"></i> mdi mdi-microsoft
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-minecraft"></i> mdi mdi-minecraft
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-minus"></i> mdi mdi-minus
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-minus-box"></i> mdi mdi-minus-box
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-minus-circle"></i> mdi mdi-minus-circle
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-minus-circle-outline"></i> mdi mdi-minus-circle-outline
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-minus-network"></i> mdi mdi-minus-network
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-mixcloud"></i> mdi mdi-mixcloud
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-monitor"></i> mdi mdi-monitor
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-monitor-multiple"></i> mdi mdi-monitor-multiple
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-more"></i> mdi mdi-more
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-motorbike"></i> mdi mdi-motorbike
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-mouse"></i> mdi mdi-mouse
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-mouse-off"></i> mdi mdi-mouse-off
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-mouse-variant"></i> mdi mdi-mouse-variant
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-mouse-variant-off"></i> mdi mdi-mouse-variant-off
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-move-resize"></i> mdi mdi-move-resize
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-move-resize-variant"></i> mdi mdi-move-resize-variant
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-movie"></i> mdi mdi-movie
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-multiplication"></i> mdi mdi-multiplication
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-multiplication-box"></i> mdi mdi-multiplication-box
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-music-box"></i> mdi mdi-music-box
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-music-box-outline"></i> mdi mdi-music-box-outline
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-music-circle"></i> mdi mdi-music-circle
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-music-note"></i> mdi mdi-music-note
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-music-note-bluetooth"></i> mdi mdi-music-note-bluetooth
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-music-note-bluetooth-off"></i> mdi mdi-music-note-bluetooth-off
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-music-note-eighth"></i> mdi mdi-music-note-eighth
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-music-note-half"></i> mdi mdi-music-note-half
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-music-note-off"></i> mdi mdi-music-note-off
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-music-note-quarter"></i> mdi mdi-music-note-quarter
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-music-note-sixteenth"></i> mdi mdi-music-note-sixteenth
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-music-note-whole"></i> mdi mdi-music-note-whole
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-nature"></i> mdi mdi-nature
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-nature-people"></i> mdi mdi-nature-people
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-navigation"></i> mdi mdi-navigation
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-near-me"></i> mdi mdi-near-me
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-needle"></i> mdi mdi-needle
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-nest-protect"></i> mdi mdi-nest-protect
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-nest-thermostat"></i> mdi mdi-nest-thermostat
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-new-box"></i> mdi mdi-new-box
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-newspaper"></i> mdi mdi-newspaper
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-nfc"></i> mdi mdi-nfc
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-nfc-tap"></i> mdi mdi-nfc-tap
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-nfc-variant"></i> mdi mdi-nfc-variant
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-nodejs"></i> mdi mdi-nodejs
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-note"></i> mdi mdi-note
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-note-outline"></i> mdi mdi-note-outline
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-note-plus"></i> mdi mdi-note-plus
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-note-plus-outline"></i> mdi mdi-note-plus-outline
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-note-text"></i> mdi mdi-note-text
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-notification-clear-all"></i> mdi mdi-notification-clear-all
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-numeric"></i> mdi mdi-numeric
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-numeric-0-box"></i> mdi mdi-numeric-0-box
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-numeric-0-box-multiple-outline"></i> mdi mdi-numeric-0-box-multiple-outline
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-numeric-0-box-outline"></i> mdi mdi-numeric-0-box-outline
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-numeric-1-box"></i> mdi mdi-numeric-1-box
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-numeric-1-box-multiple-outline"></i> mdi mdi-numeric-1-box-multiple-outline
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-numeric-1-box-outline"></i> mdi mdi-numeric-1-box-outline
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-numeric-2-box"></i> mdi mdi-numeric-2-box
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-numeric-2-box-multiple-outline"></i> mdi mdi-numeric-2-box-multiple-outline
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-numeric-2-box-outline"></i> mdi mdi-numeric-2-box-outline
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-numeric-3-box"></i> mdi mdi-numeric-3-box
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-numeric-3-box-multiple-outline"></i> mdi mdi-numeric-3-box-multiple-outline
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-numeric-3-box-outline"></i> mdi mdi-numeric-3-box-outline
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-numeric-4-box"></i> mdi mdi-numeric-4-box
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-numeric-4-box-multiple-outline"></i> mdi mdi-numeric-4-box-multiple-outline
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-numeric-4-box-outline"></i> mdi mdi-numeric-4-box-outline
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-numeric-5-box"></i> mdi mdi-numeric-5-box
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-numeric-5-box-multiple-outline"></i> mdi mdi-numeric-5-box-multiple-outline
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-numeric-5-box-outline"></i> mdi mdi-numeric-5-box-outline
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-numeric-6-box"></i> mdi mdi-numeric-6-box
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-numeric-6-box-multiple-outline"></i> mdi mdi-numeric-6-box-multiple-outline
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-numeric-6-box-outline"></i> mdi mdi-numeric-6-box-outline
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-numeric-7-box"></i> mdi mdi-numeric-7-box
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-numeric-7-box-multiple-outline"></i> mdi mdi-numeric-7-box-multiple-outline
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-numeric-7-box-outline"></i> mdi mdi-numeric-7-box-outline
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-numeric-8-box"></i> mdi mdi-numeric-8-box
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-numeric-8-box-multiple-outline"></i> mdi mdi-numeric-8-box-multiple-outline
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-numeric-8-box-outline"></i> mdi mdi-numeric-8-box-outline
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-numeric-9-box"></i> mdi mdi-numeric-9-box
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-numeric-9-box-multiple-outline"></i> mdi mdi-numeric-9-box-multiple-outline
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-numeric-9-box-outline"></i> mdi mdi-numeric-9-box-outline
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-numeric-9-plus-box"></i> mdi mdi-numeric-9-plus-box
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-numeric-9-plus-box-multiple-outline"></i> mdi mdi-numeric-9-plus-box-multiple-outline
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-numeric-9-plus-box-outline"></i> mdi mdi-numeric-9-plus-box-outline
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-nutrition"></i> mdi mdi-nutrition
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-octagon"></i> mdi mdi-octagon
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-octagon-outline"></i> mdi mdi-octagon-outline
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-odnoklassniki"></i> mdi mdi-odnoklassniki
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-office"></i> mdi mdi-office
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-oil"></i> mdi mdi-oil
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-oil-temperature"></i> mdi mdi-oil-temperature
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-omega"></i> mdi mdi-omega
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-onedrive"></i> mdi mdi-onedrive
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-opacity"></i> mdi mdi-opacity
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-open-in-app"></i> mdi mdi-open-in-app
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-open-in-new"></i> mdi mdi-open-in-new
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-openid"></i> mdi mdi-openid
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-opera"></i> mdi mdi-opera
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-ornament"></i> mdi mdi-ornament
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-ornament-variant"></i> mdi mdi-ornament-variant
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-outbox"></i> mdi mdi-outbox
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-owl"></i> mdi mdi-owl
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-package"></i> mdi mdi-package
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-package-down"></i> mdi mdi-package-down
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-package-up"></i> mdi mdi-package-up
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-package-variant"></i> mdi mdi-package-variant
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-package-variant-closed"></i> mdi mdi-package-variant-closed
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-page-first"></i> mdi mdi-page-first
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-page-last"></i> mdi mdi-page-last
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-palette"></i> mdi mdi-palette
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-palette-advanced"></i> mdi mdi-palette-advanced
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-panda"></i> mdi mdi-panda
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-pandora"></i> mdi mdi-pandora
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-panorama"></i> mdi mdi-panorama
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-panorama-fisheye"></i> mdi mdi-panorama-fisheye
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-panorama-horizontal"></i> mdi mdi-panorama-horizontal
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-panorama-vertical"></i> mdi mdi-panorama-vertical
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-panorama-wide-angle"></i> mdi mdi-panorama-wide-angle
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-paper-cut-vertical"></i> mdi mdi-paper-cut-vertical
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-paperclip"></i> mdi mdi-paperclip
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-parking"></i> mdi mdi-parking
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-pause"></i> mdi mdi-pause
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-pause-circle"></i> mdi mdi-pause-circle
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-pause-circle-outline"></i> mdi mdi-pause-circle-outline
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-pause-octagon"></i> mdi mdi-pause-octagon
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-pause-octagon-outline"></i> mdi mdi-pause-octagon-outline
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-paw"></i> mdi mdi-paw
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-paw-off"></i> mdi mdi-paw-off
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-pen"></i> mdi mdi-pen
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-pencil"></i> mdi mdi-pencil
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-pencil-box"></i> mdi mdi-pencil-box
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-pencil-box-outline"></i> mdi mdi-pencil-box-outline
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-pencil-lock"></i> mdi mdi-pencil-lock
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-pencil-off"></i> mdi mdi-pencil-off
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-percent"></i> mdi mdi-percent
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-pharmacy"></i> mdi mdi-pharmacy
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-phone"></i> mdi mdi-phone
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-phone-bluetooth"></i> mdi mdi-phone-bluetooth
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-phone-classNameic"></i> mdi mdi-phone-classNameic
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-phone-forward"></i> mdi mdi-phone-forward
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-phone-hangup"></i> mdi mdi-phone-hangup
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-phone-in-talk"></i> mdi mdi-phone-in-talk
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-phone-incoming"></i> mdi mdi-phone-incoming
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-phone-locked"></i> mdi mdi-phone-locked
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-phone-log"></i> mdi mdi-phone-log
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-phone-minus"></i> mdi mdi-phone-minus
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-phone-missed"></i> mdi mdi-phone-missed
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-phone-outgoing"></i> mdi mdi-phone-outgoing
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-phone-paused"></i> mdi mdi-phone-paused
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-phone-plus"></i> mdi mdi-phone-plus
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-phone-settings"></i> mdi mdi-phone-settings
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-phone-voip"></i> mdi mdi-phone-voip
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-pi"></i> mdi mdi-pi
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-pi-box"></i> mdi mdi-pi-box
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-pig"></i> mdi mdi-pig
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-pill"></i> mdi mdi-pill
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-pin"></i> mdi mdi-pin
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-pin-off"></i> mdi mdi-pin-off
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-pine-tree"></i> mdi mdi-pine-tree
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-pine-tree-box"></i> mdi mdi-pine-tree-box
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-pinterest"></i> mdi mdi-pinterest
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-pinterest-box"></i> mdi mdi-pinterest-box
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-pizza"></i> mdi mdi-pizza
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-play"></i> mdi mdi-play
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-play-box-outline"></i> mdi mdi-play-box-outline
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-play-circle"></i> mdi mdi-play-circle
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-play-circle-outline"></i> mdi mdi-play-circle-outline
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-play-pause"></i> mdi mdi-play-pause
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-play-protected-content"></i> mdi mdi-play-protected-content
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-playlist-check"></i> mdi mdi-playlist-check
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-playlist-minus"></i> mdi mdi-playlist-minus
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-playlist-play"></i> mdi mdi-playlist-play
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-playlist-plus"></i> mdi mdi-playlist-plus
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-playlist-remove"></i> mdi mdi-playlist-remove
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-playstation"></i> mdi mdi-playstation
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-plus"></i> mdi mdi-plus
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-plus-box"></i> mdi mdi-plus-box
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-plus-circle"></i> mdi mdi-plus-circle
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-plus-circle-multiple-outline"></i> mdi mdi-plus-circle-multiple-outline
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-plus-circle-outline"></i> mdi mdi-plus-circle-outline
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-plus-network"></i> mdi mdi-plus-network
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-plus-one"></i> mdi mdi-plus-one
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-pocket"></i> mdi mdi-pocket
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-pokeball"></i> mdi mdi-pokeball
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-polaroid"></i> mdi mdi-polaroid
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-poll"></i> mdi mdi-poll
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-poll-box"></i> mdi mdi-poll-box
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-polymer"></i> mdi mdi-polymer
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-pool"></i> mdi mdi-pool
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-popcorn"></i> mdi mdi-popcorn
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-pot"></i> mdi mdi-pot
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-pot-mix"></i> mdi mdi-pot-mix
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-pound"></i> mdi mdi-pound
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-pound-box"></i> mdi mdi-pound-box
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-power"></i> mdi mdi-power
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-power-settings"></i> mdi mdi-power-settings
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-power-socket"></i> mdi mdi-power-socket
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-presentation"></i> mdi mdi-presentation
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-presentation-play"></i> mdi mdi-presentation-play
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-printer"></i> mdi mdi-printer
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-printer-3d"></i> mdi mdi-printer-3d
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-printer-alert"></i> mdi mdi-printer-alert
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-priority-high"></i> mdi mdi-priority-high
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-priority-low"></i> mdi mdi-priority-low
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-professional-hexagon"></i> mdi mdi-professional-hexagon
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-projector"></i> mdi mdi-projector
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-projector-screen"></i> mdi mdi-projector-screen
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-pulse"></i> mdi mdi-pulse
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-puzzle"></i> mdi mdi-puzzle
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-qqchat"></i> mdi mdi-qqchat
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-qrcode"></i> mdi mdi-qrcode
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-qrcode-scan"></i> mdi mdi-qrcode-scan
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-quadcopter"></i> mdi mdi-quadcopter
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-quality-high"></i> mdi mdi-quality-high
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-quicktime"></i> mdi mdi-quicktime
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-radar"></i> mdi mdi-radar
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-radiator"></i> mdi mdi-radiator
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-radio"></i> mdi mdi-radio
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-radio-handheld"></i> mdi mdi-radio-handheld
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-radio-tower"></i> mdi mdi-radio-tower
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-radioactive"></i> mdi mdi-radioactive
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-radiobox-blank"></i> mdi mdi-radiobox-blank
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-radiobox-marked"></i> mdi mdi-radiobox-marked
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-raspberrypi"></i> mdi mdi-raspberrypi
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-ray-end"></i> mdi mdi-ray-end
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-ray-end-arrow"></i> mdi mdi-ray-end-arrow
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-ray-start-end"></i> mdi mdi-ray-start-end
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-ray-vertex"></i> mdi mdi-ray-vertex
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-rdio"></i> mdi mdi-rdio
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-read"></i> mdi mdi-read
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-readability"></i> mdi mdi-readability
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-receipt"></i> mdi mdi-receipt
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-record"></i> mdi mdi-record
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-record-rec"></i> mdi mdi-record-rec
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-recycle"></i> mdi mdi-recycle
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-reddit"></i> mdi mdi-reddit
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-redo"></i> mdi mdi-redo
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-redo-variant"></i> mdi mdi-redo-variant
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-refresh"></i> mdi mdi-refresh
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-regex"></i> mdi mdi-regex
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-relative-scale"></i> mdi mdi-relative-scale
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-reload"></i> mdi mdi-reload
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-remote"></i> mdi mdi-remote
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-rename-box"></i> mdi mdi-rename-box
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-repeat"></i> mdi mdi-repeat
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-repeat-off"></i> mdi mdi-repeat-off
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-repeat-once"></i> mdi mdi-repeat-once
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-replay"></i> mdi mdi-replay
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-reply"></i> mdi mdi-reply
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-reply-all"></i> mdi mdi-reply-all
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-reproduction"></i> mdi mdi-reproduction
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-resize-bottom-right"></i> mdi mdi-resize-bottom-right
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-responsive"></i> mdi mdi-responsive
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-rewind"></i> mdi mdi-rewind
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-ribbon"></i> mdi mdi-ribbon
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-road"></i> mdi mdi-road
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-road-variant"></i> mdi mdi-road-variant
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-rocket"></i> mdi mdi-rocket
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-rotate-3d"></i> mdi mdi-rotate-3d
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-rotate-left"></i> mdi mdi-rotate-left
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-rotate-left-variant"></i> mdi mdi-rotate-left-variant
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-rotate-right"></i> mdi mdi-rotate-right
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-rotate-right-variant"></i> mdi mdi-rotate-right-variant
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-rounded-corner"></i> mdi mdi-rounded-corner
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-router-wireless"></i> mdi mdi-router-wireless
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-routes"></i> mdi mdi-routes
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-rowing"></i> mdi mdi-rowing
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-rss"></i> mdi mdi-rss
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-rss-box"></i> mdi mdi-rss-box
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-ruler"></i> mdi mdi-ruler
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-run"></i> mdi mdi-run
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-sale"></i> mdi mdi-sale
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-satellite"></i> mdi mdi-satellite
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-satellite-variant"></i> mdi mdi-satellite-variant
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-saxophone"></i> mdi mdi-saxophone
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-scale"></i> mdi mdi-scale
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-scale-balance"></i> mdi mdi-scale-balance
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-scale-bathroom"></i> mdi mdi-scale-bathroom
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-school"></i> mdi mdi-school
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-screen-rotation"></i> mdi mdi-screen-rotation
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-screen-rotation-lock"></i> mdi mdi-screen-rotation-lock
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-screwdriver"></i> mdi mdi-screwdriver
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-script"></i> mdi mdi-script
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-sd"></i> mdi mdi-sd
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-seal"></i> mdi mdi-seal
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-seat-flat"></i> mdi mdi-seat-flat
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-seat-flat-angled"></i> mdi mdi-seat-flat-angled
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-seat-individual-suite"></i> mdi mdi-seat-individual-suite
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-seat-legroom-extra"></i> mdi mdi-seat-legroom-extra
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-seat-legroom-normal"></i> mdi mdi-seat-legroom-normal
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-seat-legroom-reduced"></i> mdi mdi-seat-legroom-reduced
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-seat-recline-extra"></i> mdi mdi-seat-recline-extra
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-seat-recline-normal"></i> mdi mdi-seat-recline-normal
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-security"></i> mdi mdi-security
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-security-network"></i> mdi mdi-security-network
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-select"></i> mdi mdi-select
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-select-all"></i> mdi mdi-select-all
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-select-inverse"></i> mdi mdi-select-inverse
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-select-off"></i> mdi mdi-select-off
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-selection"></i> mdi mdi-selection
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-send"></i> mdi mdi-send
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-serial-port"></i> mdi mdi-serial-port
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-server"></i> mdi mdi-server
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-server-minus"></i> mdi mdi-server-minus
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-server-network"></i> mdi mdi-server-network
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-server-network-off"></i> mdi mdi-server-network-off
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-server-off"></i> mdi mdi-server-off
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-server-plus"></i> mdi mdi-server-plus
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-server-remove"></i> mdi mdi-server-remove
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-server-security"></i> mdi mdi-server-security
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-settings"></i> mdi mdi-settings
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-settings-box"></i> mdi mdi-settings-box
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-shape-circle-plus"></i> mdi mdi-shape-circle-plus
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-shape-plus"></i> mdi mdi-shape-plus
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-shape-polygon-plus"></i> mdi mdi-shape-polygon-plus
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-shape-rectangle-plus"></i> mdi mdi-shape-rectangle-plus
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-shape-square-plus"></i> mdi mdi-shape-square-plus
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-share"></i> mdi mdi-share
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-share-variant"></i> mdi mdi-share-variant
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-shield"></i> mdi mdi-shield
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-shield-outline"></i> mdi mdi-shield-outline
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-shopping"></i> mdi mdi-shopping
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-shopping-music"></i> mdi mdi-shopping-music
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-shredder"></i> mdi mdi-shredder
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-shuffle"></i> mdi mdi-shuffle
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-shuffle-disabled"></i> mdi mdi-shuffle-disabled
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-shuffle-variant"></i> mdi mdi-shuffle-variant
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-sigma"></i> mdi mdi-sigma
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-sigma-lower"></i> mdi mdi-sigma-lower
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-sign-caution"></i> mdi mdi-sign-caution
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-signal"></i> mdi mdi-signal
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-signal-variant"></i> mdi mdi-signal-variant
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-silverware"></i> mdi mdi-silverware
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-silverware-fork"></i> mdi mdi-silverware-fork
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-silverware-spoon"></i> mdi mdi-silverware-spoon
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-silverware-variant"></i> mdi mdi-silverware-variant
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-sim"></i> mdi mdi-sim
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-sim-alert"></i> mdi mdi-sim-alert
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-sim-off"></i> mdi mdi-sim-off
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-sitemap"></i> mdi mdi-sitemap
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-skip-backward"></i> mdi mdi-skip-backward
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-skip-forward"></i> mdi mdi-skip-forward
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-skip-next"></i> mdi mdi-skip-next
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-skip-next-circle"></i> mdi mdi-skip-next-circle
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-skip-next-circle-outline"></i> mdi mdi-skip-next-circle-outline
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-skip-previous"></i> mdi mdi-skip-previous
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-skip-previous-circle"></i> mdi mdi-skip-previous-circle
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-skip-previous-circle-outline"></i> mdi mdi-skip-previous-circle-outline
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-skype"></i> mdi mdi-skype
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-skype-business"></i> mdi mdi-skype-business
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-slack"></i> mdi mdi-slack
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-sleep"></i> mdi mdi-sleep
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-sleep-off"></i> mdi mdi-sleep-off
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-smoking"></i> mdi mdi-smoking
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-smoking-off"></i> mdi mdi-smoking-off
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-snapchat"></i> mdi mdi-snapchat
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-snowman"></i> mdi mdi-snowman
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-soccer"></i> mdi mdi-soccer
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-sofa"></i> mdi mdi-sofa
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-sort"></i> mdi mdi-sort
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-sort-alphabetical"></i> mdi mdi-sort-alphabetical
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-sort-ascending"></i> mdi mdi-sort-ascending
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-sort-descending"></i> mdi mdi-sort-descending
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-sort-numeric"></i> mdi mdi-sort-numeric
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-sort-variant"></i> mdi mdi-sort-variant
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-soundcloud"></i> mdi mdi-soundcloud
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-source-branch"></i> mdi mdi-source-branch
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-source-fork"></i> mdi mdi-source-fork
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-source-merge"></i> mdi mdi-source-merge
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-source-pull"></i> mdi mdi-source-pull
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-speaker"></i> mdi mdi-speaker
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-speaker-off"></i> mdi mdi-speaker-off
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-speedometer"></i> mdi mdi-speedometer
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-spellcheck"></i> mdi mdi-spellcheck
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-spotify"></i> mdi mdi-spotify
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-spotlight"></i> mdi mdi-spotlight
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-spotlight-beam"></i> mdi mdi-spotlight-beam
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-spray"></i> mdi mdi-spray
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-square-inc"></i> mdi mdi-square-inc
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-square-inc-cash"></i> mdi mdi-square-inc-cash
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-stackexchange"></i> mdi mdi-stackexchange
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-stackoverflow"></i> mdi mdi-stackoverflow
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-stairs"></i> mdi mdi-stairs
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-star"></i> mdi mdi-star
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-star-circle"></i> mdi mdi-star-circle
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-star-half"></i> mdi mdi-star-half
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-star-off"></i> mdi mdi-star-off
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-star-outline"></i> mdi mdi-star-outline
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-steam"></i> mdi mdi-steam
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-steering"></i> mdi mdi-steering
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-step-backward"></i> mdi mdi-step-backward
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-step-backward-2"></i> mdi mdi-step-backward-2
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-step-forward"></i> mdi mdi-step-forward
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-step-forward-2"></i> mdi mdi-step-forward-2
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-stethoscope"></i> mdi mdi-stethoscope
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-sticker"></i> mdi mdi-sticker
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-stocking"></i> mdi mdi-stocking
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-stop"></i> mdi mdi-stop
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-stop-circle"></i> mdi mdi-stop-circle
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-stop-circle-outline"></i> mdi mdi-stop-circle-outline
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-store"></i> mdi mdi-store
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-store-24-hour"></i> mdi mdi-store-24-hour
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-stove"></i> mdi mdi-stove
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-subdirectory-arrow-left"></i> mdi mdi-subdirectory-arrow-left
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-subdirectory-arrow-right"></i> mdi mdi-subdirectory-arrow-right
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-subway"></i> mdi mdi-subway
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-sunglasses"></i> mdi mdi-sunglasses
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-surround-sound"></i> mdi mdi-surround-sound
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-swap-horizontal"></i> mdi mdi-swap-horizontal
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-swap-vertical"></i> mdi mdi-swap-vertical
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-swim"></i> mdi mdi-swim
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-switch"></i> mdi mdi-switch
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-sword"></i> mdi mdi-sword
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-sync"></i> mdi mdi-sync
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-sync-alert"></i> mdi mdi-sync-alert
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-sync-off"></i> mdi mdi-sync-off
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-tab"></i> mdi mdi-tab
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-tab-unselected"></i> mdi mdi-tab-unselected
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-table"></i> mdi mdi-table
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-table-column-plus-after"></i> mdi mdi-table-column-plus-after
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-table-column-plus-before"></i> mdi mdi-table-column-plus-before
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-table-column-remove"></i> mdi mdi-table-column-remove
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-table-column-width"></i> mdi mdi-table-column-width
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-table-edit"></i> mdi mdi-table-edit
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-table-large"></i> mdi mdi-table-large
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-table-row-height"></i> mdi mdi-table-row-height
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-table-row-plus-after"></i> mdi mdi-table-row-plus-after
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-table-row-plus-before"></i> mdi mdi-table-row-plus-before
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-table-row-remove"></i> mdi mdi-table-row-remove
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-tablet"></i> mdi mdi-tablet
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-tablet-android"></i> mdi mdi-tablet-android
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-tablet-ipad"></i> mdi mdi-tablet-ipad
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-tag"></i> mdi mdi-tag
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-tag-faces"></i> mdi mdi-tag-faces
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-tag-multiple"></i> mdi mdi-tag-multiple
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-tag-outline"></i> mdi mdi-tag-outline
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-tag-text-outline"></i> mdi mdi-tag-text-outline
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-target"></i> mdi mdi-target
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-taxi"></i> mdi mdi-taxi
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-teamviewer"></i> mdi mdi-teamviewer
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-telegram"></i> mdi mdi-telegram
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-television"></i> mdi mdi-television
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-television-guide"></i> mdi mdi-television-guide
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-temperature-celsius"></i> mdi mdi-temperature-celsius
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-temperature-fahrenheit"></i> mdi mdi-temperature-fahrenheit
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-temperature-kelvin"></i> mdi mdi-temperature-kelvin
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-tennis"></i> mdi mdi-tennis
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-tent"></i> mdi mdi-tent
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-terrain"></i> mdi mdi-terrain
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-test-tube"></i> mdi mdi-test-tube
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-text-shadow"></i> mdi mdi-text-shadow
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-text-to-speech"></i> mdi mdi-text-to-speech
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-text-to-speech-off"></i> mdi mdi-text-to-speech-off
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-textbox"></i> mdi mdi-textbox
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-texture"></i> mdi mdi-texture
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-theater"></i> mdi mdi-theater
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-theme-light-dark"></i> mdi mdi-theme-light-dark
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-thermometer"></i> mdi mdi-thermometer
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-thermometer-lines"></i> mdi mdi-thermometer-lines
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-thumb-down"></i> mdi mdi-thumb-down
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-thumb-down-outline"></i> mdi mdi-thumb-down-outline
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-thumb-up"></i> mdi mdi-thumb-up
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-thumb-up-outline"></i> mdi mdi-thumb-up-outline
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-thumbs-up-down"></i> mdi mdi-thumbs-up-down
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-ticket"></i> mdi mdi-ticket
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-ticket-account"></i> mdi mdi-ticket-account
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-ticket-confirmation"></i> mdi mdi-ticket-confirmation
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-tie"></i> mdi mdi-tie
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-timelapse"></i> mdi mdi-timelapse
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-timer"></i> mdi mdi-timer
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-timer-10"></i> mdi mdi-timer-10
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-timer-3"></i> mdi mdi-timer-3
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-timer-off"></i> mdi mdi-timer-off
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-timer-sand"></i> mdi mdi-timer-sand
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-timetable"></i> mdi mdi-timetable
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-toggle-switch"></i> mdi mdi-toggle-switch
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-toggle-switch-off"></i> mdi mdi-toggle-switch-off
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-tooltip"></i> mdi mdi-tooltip
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-tooltip-edit"></i> mdi mdi-tooltip-edit
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-tooltip-image"></i> mdi mdi-tooltip-image
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-tooltip-outline"></i> mdi mdi-tooltip-outline
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-tooltip-outline-plus"></i> mdi mdi-tooltip-outline-plus
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-tooltip-text"></i> mdi mdi-tooltip-text
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-tooth"></i> mdi mdi-tooth
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-tor"></i> mdi mdi-tor
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-traffic-light"></i> mdi mdi-traffic-light
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-train"></i> mdi mdi-train
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-tram"></i> mdi mdi-tram
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-transcribe"></i> mdi mdi-transcribe
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-transcribe-close"></i> mdi mdi-transcribe-close
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-transfer"></i> mdi mdi-transfer
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-translate"></i> mdi mdi-translate
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-tree"></i> mdi mdi-tree
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-trello"></i> mdi mdi-trello
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-trending-down"></i> mdi mdi-trending-down
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-trending-neutral"></i> mdi mdi-trending-neutral
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-trending-up"></i> mdi mdi-trending-up
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-triangle"></i> mdi mdi-triangle
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-triangle-outline"></i> mdi mdi-triangle-outline
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-trophy"></i> mdi mdi-trophy
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-trophy-award"></i> mdi mdi-trophy-award
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-trophy-outline"></i> mdi mdi-trophy-outline
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-trophy-variant"></i> mdi mdi-trophy-variant
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-trophy-variant-outline"></i> mdi mdi-trophy-variant-outline
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-truck"></i> mdi mdi-truck
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-truck-delivery"></i> mdi mdi-truck-delivery
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-tshirt-crew"></i> mdi mdi-tshirt-crew
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-tshirt-v"></i> mdi mdi-tshirt-v
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-tumblr"></i> mdi mdi-tumblr
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-tumblr-reblog"></i> mdi mdi-tumblr-reblog
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-tune"></i> mdi mdi-tune
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-tune-vertical"></i> mdi mdi-tune-vertical
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-twitch"></i> mdi mdi-twitch
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-twitter"></i> mdi mdi-twitter
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-twitter-box"></i> mdi mdi-twitter-box
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-twitter-circle"></i> mdi mdi-twitter-circle
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-twitter-retweet"></i> mdi mdi-twitter-retweet
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-ubuntu"></i> mdi mdi-ubuntu
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-umbraco"></i> mdi mdi-umbraco
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-umbrella"></i> mdi mdi-umbrella
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-umbrella-outline"></i> mdi mdi-umbrella-outline
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-undo"></i> mdi mdi-undo
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-undo-variant"></i> mdi mdi-undo-variant
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-unfold-less"></i> mdi mdi-unfold-less
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-unfold-more"></i> mdi mdi-unfold-more
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-ungroup"></i> mdi mdi-ungroup
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-untappd"></i> mdi mdi-untappd
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-upload"></i> mdi mdi-upload
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-usb"></i> mdi mdi-usb
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-vector-arrange-above"></i> mdi mdi-vector-arrange-above
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-vector-arrange-below "></i> mdi mdi-vector-arrange-below
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-vector-circle"></i> mdi mdi-vector-circle
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-vector-circle-variant"></i> mdi mdi-vector-circle-variant
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-vector-combine"></i> mdi mdi-vector-combine
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-vector-curve"></i> mdi mdi-vector-curve
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-vector-difference"></i> mdi mdi-vector-difference
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-vector-difference-ab"></i> mdi mdi-vector-difference-ab
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-vector-difference-ba"></i> mdi mdi-vector-difference-ba
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-vector-intersection"></i> mdi mdi-vector-intersection
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-vector-line"></i> mdi mdi-vector-line
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-vector-point"></i> mdi mdi-vector-point
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-vector-polygon"></i> mdi mdi-vector-polygon
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-vector-polyline "></i> mdi mdi-vector-polyline
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-vector-rectangle"></i> mdi mdi-vector-rectangle
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-vector-selection "></i> mdi mdi-vector-selection
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-vector-square"></i> mdi mdi-vector-square
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-vector-triangle"></i> mdi mdi-vector-triangle
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-vector-union"></i> mdi mdi-vector-union
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-verified"></i> mdi mdi-verified
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-vibrate "></i> mdi mdi-vibrate
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-video"></i> mdi mdi-video
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-video-off"></i> mdi mdi-video-off
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-video-switch"></i> mdi mdi-video-switch
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-view-agenda"></i> mdi mdi-view-agenda
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-view-array"></i> mdi mdi-view-array
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-view-carousel"></i> mdi mdi-view-carousel
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-view-column"></i> mdi mdi-view-column
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-view-dashboard"></i> mdi mdi-view-dashboard
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-view-day"></i> mdi mdi-view-day
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-view-grid"></i> mdi mdi-view-grid
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-view-headline"></i> mdi mdi-view-headline
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-view-list"></i> mdi mdi-view-list
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-view-module"></i> mdi mdi-view-module
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-view-quilt"></i> mdi mdi-view-quilt
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-view-stream"></i> mdi mdi-view-stream
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-view-week"></i> mdi mdi-view-week
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-vimeo "></i> mdi mdi-vimeo
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-vine"></i> mdi mdi-vine
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-violin"></i> mdi mdi-violin
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-visualstudio"></i> mdi mdi-visualstudio
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-vk"></i> mdi mdi-vk
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-vk-box"></i> mdi mdi-vk-box
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-vk-circle"></i> mdi mdi-vk-circle
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-vlc"></i> mdi mdi-vlc
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-voice"></i> mdi mdi-voice
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-voicemail"></i> mdi mdi-voicemail
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-volume-high"></i> mdi mdi-volume-high
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-volume-low"></i> mdi mdi-volume-low
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-volume-medium"></i> mdi mdi-volume-medium
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-volume-off"></i> mdi mdi-volume-off
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-vpn"></i> mdi mdi-vpn
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-walk"></i> mdi mdi-walk
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-wallet"></i> mdi mdi-wallet
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-wallet-giftcard"></i> mdi mdi-wallet-giftcard
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-wallet-membership"></i> mdi mdi-wallet-membership
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-wallet-travel"></i> mdi mdi-wallet-travel
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-wan"></i> mdi mdi-wan
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-watch"></i> mdi mdi-watch
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-watch-export"></i> mdi mdi-watch-export
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-watch-import"></i> mdi mdi-watch-import
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-water"></i> mdi mdi-water
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-water-off"></i> mdi mdi-water-off
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-water-percent"></i> mdi mdi-water-percent
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-water-pump"></i> mdi mdi-water-pump
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-watermark"></i> mdi mdi-watermark
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-weather-cloudy"></i> mdi mdi-weather-cloudy
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-weather-fog"></i> mdi mdi-weather-fog
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-weather-hail"></i> mdi mdi-weather-hail
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-weather-lightning"></i> mdi mdi-weather-lightning
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-weather-night"></i> mdi mdi-weather-night
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-weather-partlycloudy"></i> mdi mdi-weather-partlycloudy
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-weather-pouring"></i> mdi mdi-weather-pouring
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-weather-rainy"></i> mdi mdi-weather-rainy
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-weather-snowy"></i> mdi mdi-weather-snowy
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-weather-sunny"></i> mdi mdi-weather-sunny
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-weather-sunset "></i> mdi mdi-weather-sunset
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-weather-sunset-down"></i> mdi mdi-weather-sunset-down
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-weather-sunset-up"></i> mdi mdi-weather-sunset-up
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-weather-windy"></i> mdi mdi-weather-windy
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-weather-windy-variant"></i> mdi mdi-weather-windy-variant
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-web"></i> mdi mdi-web
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-webcam"></i> mdi mdi-webcam
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-webhook"></i> mdi mdi-webhook
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-wechat"></i> mdi mdi-wechat
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-weight"></i> mdi mdi-weight
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-weight-kilogram"></i> mdi mdi-weight-kilogrammdi-whatsapp
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-whatsapp"></i> mdi mdi-whatsapp
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-wheelchair-accessibility "></i> mdi mdi-wheelchair-accessibility
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-white-balance-auto"></i> mdi mdi-white-balance-auto
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-white-balance-incandescent "></i> mdi mdi-white-balance-incandescent
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-white-balance-iridescent"></i> mdi mdi-white-balance-iridescent
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-white-balance-sunny"></i> mdi mdi-white-balance-sunny
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-wifi"></i> mdi mdi-wifi
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-wifi-off"></i> mdi mdi-wifi-off
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-wii"></i> mdi mdi-wii
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-wikipedia"></i> mdi mdi-wikipedia
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-window-close"></i> mdi mdi-window-close
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-window-closed"></i> mdi mdi-window-closed
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-window-maximize"></i> mdi mdi-window-maximize
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-window-minimize"></i> mdi mdi-window-minimize
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-window-open"></i> mdi mdi-window-open
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-window-restore"></i> mdi mdi-window-restore
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-windows"></i> mdi mdi-windows
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-wordpress"></i> mdi mdi-wordpress
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-worker"></i> mdi mdi-worker
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-wrap "></i> mdi mdi-wrap
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-wrench"></i> mdi mdi-wrench
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-wunderlist"></i> mdi mdi-wunderlist
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-xaml"></i> mdi mdi-xaml
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-xbox"></i> mdi mdi-xbox
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-xbox-controller"></i> mdi mdi-xbox-controller
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-xbox-controller-off"></i> mdi mdi-xbox-controller-off
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-xda"></i> mdi mdi-xda
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-xing"></i> mdi mdi-xing
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-xing-box"></i> mdi mdi-xing-box
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-xing-circle"></i> mdi mdi-xing-circle
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-xml"></i> mdi mdi-xml
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-yeast"></i> mdi mdi-yeast
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-yelp"></i> mdi mdi-yelp
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-youtube-play"></i> mdi mdi-youtube-play
                                    </div>
                                    <div className="col-xl-3 col-md-4 col-sm-6">
                                        <i className="mdi mdi-zip-box"></i> mdi mdi-zip-box
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div> 
                </div> 
            </div> 
        </div>
           </AUX>
        );
    }
}

export default Icons_material;   